export default __webpack_public_path__ + "static/media/add-manually.5af67ae3.svg";